export const TILE_FORMATS = Object.freeze({
  MVT: 'mvt',
  JSON: 'json',
  GEOJSON: 'geojson',
  BINARY: 'binary'
});
